import { BarraDelCentro } from '@/components/BarraDelCentro';
import { Compositor } from './Compositor';
import { Historial } from './Historial';

/**
 * Comunicaciones.tsx — la pantalla de `#centro-notificaciones`.
 *
 * Es la **puerta del módulo 6**: el único enlace del menú lateral
 * (`index.html:389`) lleva aquí. La otra pantalla del centro —«Mensajes
 * directos», todavía en vanilla— no tiene entrada propia en el menú y solo se
 * alcanza desde la barra de arriba. Eso no estaba escrito en ninguna parte
 * antes del 2026-09-15 y es lo que decidió migrar esta primero.
 *
 * ## Las dos mitades cargan por separado
 *
 * El compositor y el historial son dos consultas independientes. En el vanilla
 * eran un `Promise.all` con un `catch` común, y por eso un fallo del historial
 * dejaba sin compositor a quien solo quería escribir un comunicado.
 *
 * ## El título de la pantalla
 *
 * La cabecera dice «Centro de Notificaciones» y el `PAGE_MAP` pone
 * «Comunicaciones» en la barra superior del shell. Se conservan los dos como
 * estaban: el primero nombra el CENTRO —que son las dos pantallas juntas— y el
 * segundo nombra la pantalla concreta en la que estás. Cambiar cualquiera de
 * los dos es una decisión de nomenclatura del módulo entero, no de esta opción.
 */
export function Comunicaciones() {
  return (
    <>
      <header className="mb-5">
        <h1 className="flex items-center gap-2 text-6 font-bold text-brand-ink">
          <i className="bi bi-megaphone" aria-hidden="true" />
          Centro de Notificaciones
        </h1>
        <p className="mt-1 text-3 text-muted">
          Comunicados multicanal y mensajes directos, en un solo lugar.
        </p>
      </header>

      <BarraDelCentro activa="comunicaciones" />

      {/* Una columna hasta `lg`. El vanilla montaba las dos columnas con
          `minmax(0,1.1fr) minmax(0,.9fr)` sin ningún punto de ruptura propio:
          a 375 px eso deja el compositor y el historial compitiendo por un
          ancho que no da para ninguno de los dos. */}
      <div className="grid grid-cols-1 items-start gap-5 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)]">
        <Compositor />
        <Historial />
      </div>
    </>
  );
}
